module.exports = __webpack_public_path__ + "assets/1d5779e4e6b62527964d0aa471a6aa67.mp3";